import { useEffect } from "react";
import { useEnvironment } from "@aviv-unified-frontend/runtime/environment";

import { useOverlayOrchestrator } from "../../createOverlayOrchestratorContext";
import { useOverlayStepsOrchestrator } from "../../useOverlayStepsOrchestrator";
import { BRAND_CONFIGURATION } from "../../../../../configs/brands";
import { isIOSSafari } from "../../../../utils/isIOSSafari";

const KEY = "custom-banner";
const EXCLUDED_APPS = ["app_serp_map", "app_esfu_estimaLandingPage"];

export const useInitCustomBanner = () => {
  const {
    application: { id },
  } = useEnvironment();

  const { dispatch } = useOverlayOrchestrator();
  const canProceed = useOverlayStepsOrchestrator(KEY);

  useEffect(() => {
    if (!canProceed) return;

    const isDisabled =
      !id ||
      !BRAND_CONFIGURATION.appBanner?.custom?.[id] ||
      EXCLUDED_APPS.includes(id) ||
      /**
       * The banner must not be displayed on the Classified Details Page (CDP) for users on iOS mobile Safari to avoid conflicts with App Clips.
       */
      (id === "app_cldp" && isIOSSafari());

    if (isDisabled) {
      dispatch({ type: "DISABLE", payload: KEY });

      return;
    }

    dispatch({ type: "INIT", payload: KEY });
  }, [id, canProceed, dispatch]);
};
